import { useMeta, computed } from '@nuxtjs/composition-api';
import { Article } from '~/models/Article';
import { createSocialCardsTags } from '~/utils/socialCardsTags';
import { withStoryblokHeaderImgResize } from '~/utils/helpers';

export function useArticlePageMeta(rawArticle) {
  useMeta(() => {
    const article = computed(() => new Article(rawArticle.value));
    const title = article.value.metaInfo?.title || article.value.title;
    const description = article.value.metaInfo?.description || article.value.description;
    const fullUrl = `${article.value.fullUrl}/`;
    const imageSrc = withStoryblokHeaderImgResize(article.value.coverImg.src);

    const faqs = article.value.faqs.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer
      }
    }));

    return {
      title,
      meta: [
        ...createSocialCardsTags({
          description,
          title,
          pageUrl: fullUrl,
          imageSrc,
        })
      ],
      link: [
        { rel: 'canonical', href: fullUrl }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'http://schema.org',
            '@type': 'Article',
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': fullUrl
            },
            headline: title,
            description,
            image: imageSrc,
            author: {
              '@type': 'Person',
              name: article.value.author.name,
              url: process.env.NUXT_ENV_BASE_URL,
            },
            publisher: {
              '@type': 'Organization',
              name: 'FightCamp',
              logo: {
                '@type': 'ImageObject',
                url: 'https://cdn3.joinfightcamp.com/logos/fightcamp-logo-stacked-blue-small-usage.png'
              }
            },
            datePublished: article.value.schedule,
            dateModified: article.value.publishedAt,
          }
        },
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs,
          }
        }
      ]
    };
  });
}
